import { deleteCall, getCall, postCall, putCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const getContacts = async ({
  page = 1,
  pageSize = 10,
  filters = [],
  sortField = "name",
  sortOrder = "asc",
} = {}) => {
  const bot_id = localStorage.getItem("bot");
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
    sort_by: sortField,
    sort_order: sortOrder,
  });

  if (filters.length > 0) {
    query.set("filters", JSON.stringify(filters));
  }

  const res = await getCall(`/contacts/${bot_id}?${query.toString()}`);
  if (!res[0]) {
    dispatchErrorMessage(null, res, "Error al obtener los contactos.");
    return null;
  }

  const { contacts, total, page: responsePage, page_size: responsePageSize } =
    res[0];

  if (
    !Array.isArray(contacts) ||
    !Number.isInteger(total) ||
    total < 0 ||
    !Number.isInteger(responsePage) ||
    responsePage < 1 ||
    !Number.isInteger(responsePageSize) ||
    responsePageSize < 1
  ) {
    dispatchErrorMessage(
      null,
      null,
      "La API de contactos debe devolver contactos paginados. Revisa el contrato de filtrado de contactos."
    );
    return null;
  }

  return {
    contacts,
    total,
    page: responsePage,
    pageSize: responsePageSize,
  };
};

export const getContactsSimpleData = async (name = "") => {
  const bot_id = localStorage.getItem("bot");
  const query = new URLSearchParams();
  if (name.trim()) query.set("name", name.trim());
  const res = await getCall(
    "/contacts/simple/data/" + bot_id + (query.size ? `?${query}` : "")
  );
  if (res[0]) {
    return res[0].contacts;
  } else return null;
};

export const getContactsRegistry = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/contacts/register/" + bot_id);
  if (res[0]) {
    return res[0].contacts;
  } else return null;
};

export const getContactsGroups = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/access/company/" + bot_id);
  if (res[0]) {
    return res[0].companies;
  } else return null;
};

export const getContactExternalData = async (external_id, api_service) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();

  const res = await getCall(`/contacts/info/request/${bot_id}?external_id=${external_id}&api_service=${api_service}`);

  if (res[0]) {
    updateToast(id, "success", "Datos del contacto obtenidos correctamente");
    return res[0].contact_info;
  } else {
    dispatchErrorMessage(id, res, "Error al obtener los datos del contacto");
    return null;
  }
};

export const getContactVariablesData = async (contact_id, sender_id, api_service) => {
  const bot_id = localStorage.getItem("bot");
  
  const res = await getCall(`/contacts/info/variables/${bot_id}?contact_id=${contact_id}&sender_id=${sender_id}&api_service=${api_service}`);

  if (res[0]) {
    return res[0].contact_variables;
  } else {
    const id = loadingToast();
    dispatchErrorMessage(id, res, "Error al obtener los datos del contacto.");
    return null;
  }
};

export const deleteContact = async (idContact) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/contacts/" + bot_id + "/" + idContact);
  if (res[0]) {
    updateToast(id, "success", "Contacto borrado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al borrar el contacto");
    return null;
  }
};

export const deleteContactReg = async (contactRegId) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/contacts/register/" + bot_id + "/" + contactRegId);
  if (res[0]) {
    updateToast(id, "success", "Registro borrado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al borrar el registro.");
    return null;
  }
};

export const saveNewContact = async (contact) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/contacts/" + bot_id,
    {
      name: contact.name,
      phone: contact.phone,
      external_id: contact.external_id,
      company_id: contact.company_id,
    }
  );
  if (res[0]) {
    updateToast(id, "success", "Contacto guardado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al agregar contacto");
    return null;
  }
};

export const saveEditContact = async (contact) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = { ...contact };
  if (data.phone?.length < 6) {
    data.phone = "";
  }
  const res = await putCall("/contacts/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Contacto editado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al editar el contacto");
    return null;
  }
};
export const moveContacts = async (contacts, group) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/contacts/register/" + bot_id, {
    company_id: group,
    contacts: contacts,
  });
  if (res[0]) {
    updateToast(id, "success", "Contactos agregados correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al agregar los contactos");
    return null;
  }
};
export const importContacts = async (contacts, groupSelected) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/contacts/import/" + bot_id, {
    ...contacts,
    company_id: groupSelected,
  });
  if (res[0]) {
    let msg = "Contactos agregados correctamente";
    if (res[0] && res[0]) {
      if (res[0].data) {
        msg = res[0].data.message;
      } else if (res[0].message) {
        msg = res[0].message;
      }
    }
    updateToast(id, "success", msg);
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al agregar los contactos");
    return null;
  }
};

// ============= CONTACTS GROUPS
export const getContactsGroupsList = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/contacts/groups/" + bot_id);
  if (res[0]) {
    return res[0].contacts_groups;
  } else return null;
};

export const getContactsGroupsDetails = async (group_id) => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/contacts/groups/" + bot_id + "/" + group_id);
  if (res[0]) {
    return res[0].contacts_group;
  } else return null;
};

export const getContactsGroupsDefaultSettings = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/contacts/groups/default/settings/" + bot_id);
  if (res[0]) {
    return res[0].default_contacts_group;
  } else return null;
};

export const saveNewContactsGroup = async (company_name) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const data = { company_name: company_name };
  const res = await postCall("/contacts/groups/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Grupo guardado correctamente.");
    return res[0].company;
  } else {
    dispatchErrorMessage(id, res, "Error al guardar el grupo.");
    return null;
  }
};

export const deleteContactsGroup = async (company_id) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/contacts/groups/" + bot_id + "/" + company_id);
  if (res[0]) {
    updateToast(id, "success", "Grupo eliminado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al eliminar el grupo.");
    return null;
  }
};

export const editContactsGroup = async (company_id, company_data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/contacts/groups/" + bot_id + "/" + company_id, company_data);
  if (res[0]) {
    updateToast(id, "success", "Grupo actualizado correctamente.");
    return res[0].company;
  } else {
    dispatchErrorMessage(id, res, "Error al actualizar el grupo.");
    return null;
  }
};

export const removeContactFromGroup = async (contact_id, group_id) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/contacts/groups/delete/" + bot_id + "/" + contact_id + "/" + group_id);

  if (res[0]) {
    updateToast(id, "success", "Contacto eliminado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al eliminar el contacto.");
    return null;
  }
};

export const addContactToGroup = async (contact, company_id) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = {
    contact_id: contact.id
  };
  if (!contact.id) {
    data = { ...data, contact: contact };
    if (data.contact.phone.length < 6) {
      data.contact.phone = "";
    }
  }
  const res = await postCall("/contacts/groups/add/" + bot_id + "/" + company_id, data);
  if (res[0]) {
    updateToast(id, "success", "Contacto agregado correctamente.");
    return res[0].contact;
  } else {
    dispatchErrorMessage(id, res, "Error al agregar el contacto.");
    return null;
  }
};